import React from "react";
import { useNavigate } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import HiDotsVertical from "../../assets/icons/dotsVertical";
import FaFlag from "../../assets/icons/flag";
import ShareIcon from "../../assets/icons/share";
import CheckIcon from "../../assets/icons/check";
import ArchiveIcon from "../../assets/icons/archive";
import UnarchiveIcon from "../../assets/icons/unarchive";
import { otherUserProfile } from "../../routes/routesPath";
import { getSlug, getUserImage } from "../../utils/helpers";
import { format_date, parseCamelKey } from "../../utils/formatersAndParsers";
import { successMsg } from "../../utils/toastMessage";
import { updateStoriesList } from "../../redux/stories/slice";
import { updateStory } from "../../redux/stories/thunk";
import { handleApiRequest } from "../../services/handleApiRequest";

export default function StoryCardHeader({
  story = {},
  showStatus = true,
  storyType = "",
  setUserAction = () => {},
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { myStoriesList = {}, privateStoriesList = {} } = useSelector(
    (state) => state.stories || {}
  );

  const getStoriesList = () => {
    if (storyType === "private") return privateStoriesList;
    if (storyType === "myStories") return myStoriesList;
  };

  const handleUpdateStoriesList = () => {
    const index = getStoriesList().records?.findIndex((item) => item._id === story._id);
    const oldStories = [...(getStoriesList().records || [])];

    if (index >= 0) {
      oldStories.splice(index, 1);
    }

    dispatch(
      updateStoriesList({
        listFor: storyType,
        records: oldStories,
        totalCount: getStoriesList().totalCount - 1,
      })
    );
  };

  const handlePrivacyStatus = async (e) => {
    e.stopPropagation();
    const response = await handleApiRequest(updateStory, {
      ...story,
      storyId: story._id,
      isPrivate: !story.isPrivate,
      category: story.category?._id,
    });
    if (response.status) {
      handleUpdateStoriesList();
      successMsg(`Story moved to ${story.isPrivate ? "Public" : "Private"} folder successfully!`);
    }
  };

  return (
    <>
      <div className="mainStoryCardHeader position-relative d-flex justify-content-between">
        <div
          className="w-fit d-flex align-items-center"
          onClick={(e) => {
            e.stopPropagation();
            if (!story.anonymousSharing && !showStatus) {
              navigate(`${otherUserProfile}/${getSlug(story.user?.name)}/${story.user?._id}`);
            }
          }}>
          <img
            src={story.anonymousSharing ? getUserImage() : getUserImage(story.user)}
            alt={story.anonymousSharing ? "userImage" : story.user?.name}
            onError={(e) => {
              e.target.src = getUserImage();
            }}
            className="img-small img-fluid rounded-circle"
          />
          <div className="ms-2">
            <p className="max-w-150 my-0 text-truncate">
              {story.anonymousSharing ? "Anonymous" : story.user?.name}
            </p>
            <p className="muted small my-0">Posted At: {format_date(story?.createdAt, "DD MMM")}</p>
          </div>
        </div>
        <div className={`storyAction position-absolute end-0 top-0 d-flex align-items-center`}>
          {showStatus && (
            <p
              className={`d-flex align-items-center rounded-pill px-3 py-2 py-sm-1 ${
                story.status === "active"
                  ? "bg-success-subtle text-success"
                  : story.status === "deleted" || story.status === "blocked"
                  ? "bg-danger text-white"
                  : "bg-success-subtle text-success"
              }`}>
              {story.status === "active" ? <CheckIcon /> : ""}
              <span className="d-none d-sm-inline ms-1">{parseCamelKey(story.status)}</span>
            </p>
          )}
          {storyType === "private" ? (
            <button
              className={`d-flex align-items-center rounded-pill px-3 py-2 py-sm-1 text-nowrap bg-header border-secondary-light`}
              onClick={handlePrivacyStatus}>
              <UnarchiveIcon />
              <span className="d-none d-sm-inline ms-1">Make Public</span>
            </button>
          ) : storyType === "myStories" ? (
            <button
              className={`d-flex align-items-center rounded-pill px-3 py-2 py-sm-1 text-nowrap bg-header border-secondary-light`}
              onClick={handlePrivacyStatus}>
              <ArchiveIcon />
              <span className="d-none d-sm-inline ms-1">Make Private</span>
            </button>
          ) : (
            ""
          )}
        </div>
        {storyType !== "private" && storyType !== "myStories" && (
          <Dropdown onClick={(e) => e.stopPropagation()} className="storyCardHeaderActions">
            <Dropdown.Toggle className="border-secondary-light">
              <p className="m-0 d-flex py-1">
                <HiDotsVertical className="text-dark" />
              </p>
            </Dropdown.Toggle>

            <Dropdown.Menu align="end" className="min-w-100 p-0 shadow-lg">
              <Dropdown.Item
                as="p"
                className="pointer m-0 px-4 d-flex align-items-center gap-1"
                onClick={(e) => {
                  e.stopPropagation();
                  setUserAction({ action: "reportStory", id: story._id });
                }}>
                <FaFlag className="me-2" />
                Report
              </Dropdown.Item>
              <Dropdown.Item
                as="p"
                className="pointer m-0 px-4 d-flex align-items-center gap-1"
                onClick={(e) => {
                  e.stopPropagation();
                  setUserAction({ action: "showSharePop" });
                }}>
                <ShareIcon className="me-2" />
                Share
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        )}
      </div>
    </>
  );
}
